import { useEffect } from 'react';

/**
 * Component to dynamically set page title
 * @param {string} title - The title to set for the page
 * @returns null - This is a utility component that doesn't render anything
 */
const PageTitle = ({ title }) => {
  useEffect(() => {
    // Set the page title
    const defaultTitle = 'Shoora Welfare Foundation';
    document.title = title ? `${title} | ${defaultTitle}` : defaultTitle;
    
    // Clean up when component unmounts
    return () => {
      document.title = defaultTitle;
    };
  }, [title]);

  return null;
};

export default PageTitle;
